/**
 * Toast notification service
 * Provides a simple API for showing toast notifications
 */

let toastCallbacks = {
  success: null,
  error: null,
  warning: null,
  info: null
};

/**
 * Register toast display callbacks
 * These should be called by the ToastProvider component
 */
export const registerToastCallbacks = (callbacks) => {
  toastCallbacks = { ...toastCallbacks, ...callbacks };
};

/**
 * Show a success toast
 */
export const showSuccessToast = (message, options = {}) => {
  if (toastCallbacks.success) {
    toastCallbacks.success(message, options);
  } else {
    console.log('[Toast Success]', message);
  }
};

/**
 * Show an error toast
 */
export const showErrorToast = (message, options = {}) => {
  if (toastCallbacks.error) {
    toastCallbacks.error(message, options);
  } else {
    console.error('[Toast Error]', message);
  }
};

/**
 * Show a warning toast
 */
export const showWarningToast = (message, options = {}) => {
  if (toastCallbacks.warning) {
    toastCallbacks.warning(message, options);
  } else {
    console.warn('[Toast Warning]', message);
  }
};

/**
 * Show an info toast
 */
export const showInfoToast = (message, options = {}) => {
  if (toastCallbacks.info) {
    toastCallbacks.info(message, options);
  } else {
    console.info('[Toast Info]', message);
  }
};
